import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'
import Section from './Section'

const styles = (theme) => ({
  story: {
    transition: 'opacity 0.8s',
    padding: 0,
    marginBottom: 8,
    '&:hover': {
      opacity: 0.5,
    },
  },
  storyFrom: {
    color: theme.palette.featured.onWhite,
  },
  title: {
    fontWeight: 400,
    fontSize: '0.8em',
  },
})

const FeaturedStories = ({ classes, header, stories }) => {
  const thumbRatio = { width: 70, height: 70 }

  return stories ? (
    <Section
      header={header}
      render={() => {
        return (
          <List>
            {stories.edges.map(({ node }, i) => (
              <ListItem
                key={`featuredStories${i + 1}`}
                component={Link}
                to={node.fields.slug}
                className={classes.story}
              >
                <Avatar
                  component={(props) => (
                    <div {...props} style={thumbRatio}>
                      <img
                        src={node.frontmatter.thumbnail}
                        alt=""
                        title={node.frontmatter.title}
                        style={{
                          ...thumbRatio,
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                  )}
                />
                <ListItemText
                  primary={node.frontmatter.storyFrom}
                  secondary={node.frontmatter.title}
                  classes={{
                    primary: classes.storyFrom,
                    secondary: classes.title,
                  }}
                />
              </ListItem>
            ))}
          </List>
        )
      }}
    />
  ) : null
}

FeaturedStories.propTypes = {
  classes: PropTypes.object.isRequired,
  header: PropTypes.string.isRequired,
  stories: PropTypes.object,
}

export default withStyles(styles)(FeaturedStories)



// WEBPACK FOOTER //
// ./src/components/Sidebar/FeaturedStories.js